import _styled from "styled-components";
const _excluded = ["width", "height"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { TABLE_SIZE_THEMES, DEFAULT_TABLE_SIZE } from '../consts';
const SKELETON_RADIUS = 8;
const SKELTON_HEIGHT = 12;
const DEFAULT_ROW_HEIGHT = TABLE_SIZE_THEMES[DEFAULT_TABLE_SIZE].rowHeight;
const SkeletonLoadingVertebra = _ref => {
  let {
      width: widthProp = 20,
      height: heightProp = DEFAULT_ROW_HEIGHT
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  let width = typeof widthProp === 'string' ? parseInt(widthProp) : widthProp;
  width = width - theme.spacing.L; // remove padding
  const rowHeight = typeof heightProp === 'string' ? parseInt(heightProp) : heightProp;
  const yCentered = rowHeight / 2 - SKELTON_HEIGHT / 2;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: width,
    $_css2: rowHeight
  }, /*#__PURE__*/React.createElement(ContentLoader, _extends({
    width: width,
    height: rowHeight
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: yCentered,
    rx: SKELETON_RADIUS,
    ry: SKELETON_RADIUS,
    width: width,
    height: SKELTON_HEIGHT
  })));
};
SkeletonLoadingVertebra.propTypes = {
  style: stylePropType
};
export default SkeletonLoadingVertebra;
var _StyledDiv = _styled("div").withConfig({
  displayName: "SkeletonLoadingVertebra___StyledDiv",
  componentId: "sc-bousrm-0"
})(p => ({
  width: p.$_css,
  height: p.$_css2
}));
//# sourceMappingURL=SkeletonLoadingVertebra.js.map